/**
 * @generated SignedSource<<83150d6ce2d9c9c01f6c542c3c0e769b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionHistoryListItem_Occasion$data = {
  readonly id: string;
  readonly sequenceNumber: number;
  readonly startAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionStatusCircle_RoutineOccasion">;
  readonly " $fragmentType": "RoutineOccasionHistoryListItem_Occasion";
};
export type RoutineOccasionHistoryListItem_Occasion$key = {
  readonly " $data"?: RoutineOccasionHistoryListItem_Occasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionHistoryListItem_Occasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionHistoryListItem_Occasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RoutineOccasionStatusCircle_RoutineOccasion"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "startAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sequenceNumber",
      "storageKey": null
    }
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
};

(node as any).hash = "4c83bd2a6d0b072c4eea77b2c7a17746";

export default node;
